import logo from "@/assets/logo.png";

export const Logo = ({ className = "h-9 w-auto" }) => (
  <img src={logo} alt="Weddings by Temple Bells" className={className} />
);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const y = el.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};
